module.exports = __webpack_public_path__ + "ca5da1b9665f91ea60f9b02d9b114ea9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/bookshelves/bookshelf-jam.png
// module id = 1601
// module chunks = 0